  <div class="recorder">
    <ng-template #name>
      <div class="d-flex justify-content-between align-items-center">
        <button nbButton class="rounded-circle" status="primary" (click)="!isRecording? startRecording(): stopRecording()"
          id="button">
          <nb-icon [icon]="isRecording? 'stop-circle-outline': 'mic-outline'"></nb-icon>
          <!-- <nb-icon icon="stop-circle-outline" *ngIf="isRecording"></nb-icon> -->
        </button>
          <span *ngIf="isRecording" class=" timer-text">{{formatTime(recordedTime)}}</span>
          <button nbButton *ngIf="isRecording" status="danger" class="border-radius-100" (click)="onCancel()">
            <nb-icon icon="close-outline"></nb-icon>
          </button>
      </div>
    </ng-template>
    <div *ngIf="!isRecording && file; else name">
      <button nbButton status="primary" class="rounded-circle" (click)="onSend()">
        <nb-icon icon="paper-plane-outline"></nb-icon>
      </button>
      <span class=" timer-text">{{formatTime(recordedTime)}}</span>
      <button nbButton status="danger" class="rounded-circle" (click)="onCancel()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </div>